import ROUTES from '../routes';
import NostroTransactions from '../hoc/nostro/nostro';
import NostroTransaction from '../hoc/nostro/transaction';
import ExpandedGeneralLedgerTransaction from '../hoc/transactions/expanded-general-ledger-panel';

const NostroRoutes = {
  path: ROUTES.NOSTRO_TRANSFERS,
  element: <NostroTransactions />,
  children: [
    {
      path: ROUTES.NOSTRO_TRANSFER,
      element: <NostroTransaction />,
    },
    {
      path: ROUTES.NOSTRO_TRANSFER_CREATE,
      element: <NostroTransaction />,
    },
    {
      path: ROUTES.NOSTRO_TRANSACTION_GL,
      element: (
        <ExpandedGeneralLedgerTransaction backLink={ROUTES.NOSTRO_TRANSFERS} />
      ),
    },
  ],
};

export default NostroRoutes;
